






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Docs",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              name: {
                attrs: {
                  label: "Name",
                },
                rules: {
                  match: {},
                },
              },
              language: {
                type: "select",
                attrs: {
                  label: "Language",
                  items: makeSelectOptions({
                    en: "English",
                    vi: "Vietnamese",
                  }),
                },
                rules: {
                  equal_to: {},
                },
              },
              disabled: {
                type: "select",
                attrs: {
                  label: "Status",
                  items: [
                    { text: "Enabled", value: false },
                    { text: "Disabled", value: true },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          displayFields: {
            name: {
              text: "Name",
              sortable: true,
            },
            language: {
              text: "Language",
              sortable: true,
              options: {
                label(value) {
                  const languages = {
                    en: "English",
                    vi: "Vietnamese",
                  };
                  return languages[value] || value;
                },
              },
            },
            disabled: {
              text: "Status",
              options: {
                label(value) {
                  return value ? "Disabled" : "Enabled";
                },
                attrs(value) {
                  return {
                    color: value ? "red" : "green",
                  };
                },
              },
            },
            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          topActionButtons: {
            add: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                text: "Add New",
                icon: "mdi-plus",
              },
              on: {
                xClick({ self }) {
                  self.$router.push("/app/settings/doc_detail");
                },
              },
            },
            export: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                text: "Export all",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  coreApiClient.download("docs", `@/export`, dataTable.getFindAllOptions());
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin"]) && {
                content: {
                  icon: "mdi-pencil",
                  color: "primary",
                  small: true,
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Edit",
                    },
                  },
                },
                on: {
                  xClick({ self }) {
                    const { item } = self.context();
                    self.$router.push(`/app/settings/doc_detail?id=${item._id}`);
                  },
                },
              },
              delete: userManager.checkRole(["systemAdmin", "admin"]) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call(
                "docs",
                "findAll",
                options
              );
              return [items, count];
            },
            async delete(item) {
              return await coreApiClient.call("docs", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
